import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FAQsComponent implements OnInit {
  hideme
  constructor() { }

  ngOnInit(): void {
  }
  changeValue() {

    this.hideme = !this.hideme;
  }
}
